<template>
  <div>
    <section class="product-details-container">
      <div class="product-details">
        <div class="product-details__info">
          <h1 class="product-details__type-title">
            <span class="product-details__type-title--left">{{productDetails.proCategoryName}}</span>
          </h1>
          <div class="product-details__left">
            <h2 class="product-details__info-title">{{productDetails.productName}}</h2>
            <h3 class="product-details__info-title-eng">{{companyInfo.fullEngName}}</h3>
            <div class="product-details__info-content">{{productDetails.productInfo}}</div>
          </div>
          <div class="product-details__right">
            <div class="product-details__images" :style="{ backgroundImage: `url('${imgSrcPrefix}${productDetails.productImg}')` }">
              <button @click="beginApplyLoan"><span>{{applyLoanBtn.text}}</span></button>
              <span class="product-details__button-desc">APPLICATION</span>
            </div>
          </div>
        </div>
        <div class="product-details__application-conditions">
          <h4 class="product-details__serial-number"><span>01</span></h4>
          <h5 class="product-details__title">申请条件</h5>
          <h6 class="product-details__title-eng">APPLICATION CONDITIONS</h6>
          <div class="product-details__content other" v-html="fixHTMLLineSeparator(productDetails.applyConditions)"></div>
        </div>
        <div class="product-details__application-people">
          <h4 class="product-details__serial-number"><span>02</span></h4>
          <h5 class="product-details__title">适用人群</h5>
          <h6 class="product-details__title-eng enother">APPLICATION PEOPLE</h6>
          <div class="product-details__content" v-html="fixHTMLLineSeparator(productDetails.forPeople)"></div>
        </div>
        <div class="product-details__materials-required">
          <h4 class="product-details__serial-number"><span>03</span></h4>
          <h5 class="product-details__title">所需材料</h5>
          <h6 class="product-details__title-eng other">MATERIALS REQUIRED</h6>
          <div class="product-details__content" v-html="fixHTMLLineSeparator(productDetails.requiedFiles)"></div>
        </div>
        <div class="product-details__suitable-city">
          <h4 class="product-details__serial-number"><span>04</span></h4>
          <h5 class="product-details__title">适用城市</h5>
          <h6 class="product-details__title-eng other">SUITABLE CITY</h6>
          <div class="product-details__content" v-html="fixHTMLLineSeparator(productDetails.productCitys)"></div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import _ from 'lodash'
  import {mapGetters, mapActions} from 'vuex'
  import api from '../vuex/api'
  import * as types from '../vuex/types'


  export default {
    data () {
      return {
        hasLoanAmount: false,
        askLoanSuccess: true,
       // productId: this.$route.params.id,
        productId: this.$route.query.productId,
        applyLoanBtn: {
          diabled: false,
          text: '立即申请'
        }
      }
    },
    computed: {
      ...mapGetters({
        imgSrcPrefix: types.GET_IMAGE_SRC_PREFIX,
        userInfo: types.GET_USER,
        companyInfo: types.GET_COMPANY_INFO,
        productDetails: types.GET_PRODUCT_DETAILS,
        isUseingLimit: types.IS_USEING_LIMIT
      })
    },
    methods: {
      ...mapActions({
        getProductDetails: types.GET_PRODUCT_DETAILS,
        setAlertMessage: types.SET_FAIL_MESSAGE,
        getApplicationQuota: types.GET_APPLICATION_QUOTA,
        getAvailableAmount: types.GET_AVAILABLE_AMOUNT
      }),
      fixHTMLLineSeparator (str) {
        if (_.isString(str)) {
          return `<p>${str.split('\n').join('</p><p>')}</p>`
        }
      },
      beginApplyLoan () {
        if (!_.isEmpty(this.userInfo)) {
          if (!this.applyLoanBtn.diabled) { // 防重复触发
            this.applyLoanBtn.diabled = true
            api.isCurrentUserInBlacklist({// 该接口仅有此处用到，也与state关系不大，暂不考虑放入store，减轻复杂度
              token: this.userInfo.token,
              productId: this.productId
            }).then((res) => {
              const resData = res.data
              this.applyLoanBtn.diabled = false
              if (Number(resData.code) === 0) { // 不在黑名单，正常进入流程
                if (this.isUseingLimit) {

                  if(Number(resData.creditModel) === 1){
                    this.$router.push(`/applyLoan/${this.$route.query.productId}/step1_xd`)
                  } else {
                  this.getAvailableAmount({// 先检测用户是否有贷款额度
                    tokenId: this.userInfo.token,
                    productId: this.productId
                  }).then((res) => {
                    const data = res.data
                    if (Number(data.code) === 1) {
                      if (Number(data.result.hasGotAmount) === 0) {  // 可用额度大于0
                        this.$confirm(`该产品还没获取额度，立即获取？`, ' ', {
                          cancelButtonText: '取消',
                          confirmButtonText: '确定',
                          type: 'warning'
                        }).then(() => {
                          this.getApplicationQuota({  // 申请产品额度
                            tokenId: this.userInfo.token,
                            productId: this.productId
                          }).then((res) => {
                            const data = res.data
                            if (Number(data.code) === 1) {
                              this.$confirm(`恭喜您获得额度${data.result.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}元`, ' ', {
                                confirmButtonText: '确定',
                                type: 'success'
                              }).then(() => {
                                this.$router.push(`/applyLoan/${this.$route.query.productId}/step1_xd`)
                              })
                            } else {
                              this.setAlertMessage({
                                show: true,
                                content: data.result
                              })
                            }
                          })
                        })
                      } else {
                        this.$router.push(`/applyLoan/${this.$route.query.productId}/step1_xd`)
                      }
                    } else {
                      this.setAlertMessage({
                        show: true,
                        content: data.result
                      })
                    }
                  })
                  }
                } else {
                  this.$router.push(`/applyLoan/${this.$route.query.productId}/step1_xd`)
                }
              } else if (Number(resData.code) === 5) { // 未填写个人或企业信息
                this.setAlertMessage({
                  show: true,
                  content: resData.result
                })
                this.$router.push('/personalCenter/MyInfo')
              } else if (Number(resData.code) === 3) { // 未实名验证
                if (Number(this.userInfo.crmCustomerType) === 1) {
                  resData.result = '请先进行实名制认证!'
                } else {
                  resData.result = '请先进行企业认证!'
                }
                this.setAlertMessage({
                  show: true,
                  content: resData.result
                })
                this.$router.push('/personalCenter/realNameAuth')
              } else if (Number(resData.code) === 2) { // 未添加银行卡
                this.setAlertMessage({
                  show: true,
                  content: resData.result
                })
                this.$router.push('/personalCenter/bankcardInfo')
              } else if (Number(resData.code) === 9) { // 未额度授信
                this.setAlertMessage({
                  show: true,
                  content: resData.result
                });
              }else { // 在黑名单，给出提示
                this.setAlertMessage({
                  show: true,
                  content: resData.result
                })
              }
            }).catch(() => {
              this.applyLoanBtn.diabled = true
            })
          }
        } else {
          // 没有登录
          this.$router.push('/login')
        }
      }
    },
    mounted () {
      //alert(this.$route.query.productId)
      this.getProductDetails({
        //productId: this.$route.params.id
        productId: this.$route.query.productId
      })
    }
  }
</script>
<style lang="scss">
  $productDetailsInfoRightWidth: 450px;
  $productDetailsInfoMiddleGap: 23px;

  @mixin chnTitle {
    line-height: 1;
    font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
    color: $darkCyan;
  }

  @mixin engTitle {
    line-height: 1;
    color: $darkerGray;
    font-family: 'Anders', Arial;
  }

  // 向右偏斜
  @mixin rotateRight {
    &:before {
      content: "";
      display: inline-block;
      width: 3000px;
      height: 3px;
      background: $darkCyan;
      position: absolute;
      top: 56px;
      left: -3032px;
    }

    &:after {
      content: "";
      @include rotate(20deg);
      display: inline-block;
      background: $darkCyan;
      width: 3px;
      height: 80px;
      vertical-align: -2px;
      margin-left: 21px;
    }
  }

  // 向左偏斜
  @mixin rotateLeft {
    &:before {
      content: "";
      @include rotate(20deg);
      display: inline-block;
      background: $darkCyan;
      width: 3px;
      height: 80px;
      vertical-align: -2px;
      margin-right: 40px;
    }

    &:after {
      content: "";
      display: inline-block;
      width: 3000px;
      height: 3px;
      background: $darkCyan;
      position: absolute;
      top: 56px;
      right: -3032px;
    }
  }

  .product-details-container {
    width: 100%;
    overflow: hidden;
    background: url('../../static/images/index_bg_1.png') repeat;
  }

  .product-details {
    @include clear;
    margin: 0 auto;
    width: $containerWidth;

    .product-details__serial-number {
      span {
        position: relative;
      }
    }

  }

  .product-details__info {
    @include clear;
    margin: 0;
    width: 100%;
    text-align: right;
  }

  .product-details__left {
    float: left;
    width: 673px; // scss calculation failed ?
  }

  .product-details__type-title {
    @include resetBFC;
    height: 220px;
    text-align: left;
    position: relative;

    &:after {
      content: url(../../static/images/scattered_2.png);
      display: inline-block;
      width: 78px;
      height: 81px;
      position: absolute;
      right: -350px;
      top: 70px;
    }
  }

  .product-details__type-title--left {
    float: left;
    margin-right: 40px;
    font-weight: 400;
    color: $lighterTrueBlack;
    font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
    font-size: 45px;
    position: relative;
    line-height: 220px;

    &:after {
      content: "";
      @include rotate(20deg);
      display: inline-block;
      background: $darkCyan;
      width: 3px;
      height: 80px;
      vertical-align: -31px;
      margin-left: 41px;
    }

    &:before {
      content: "";
      display: inline-block;
      width: 3000px;
      height: 3px;
      background: $darkCyan;
      position: absolute;
      top: 109px;
      left: -3032px;
    }
  }

  .product-details__info-title {
    padding-right: $productDetailsInfoMiddleGap;
    @include chnTitle;
    font-size: 40px;
  }

  .product-details__info-title-eng {
    margin: 20px 0;
    padding-right: $productDetailsInfoMiddleGap;
    @include engTitle;
    color: #ccc;
    font-weight: 700;
    font-size: 55px;
  }

  .product-details__info-content {
    position: relative;
    padding-right: $productDetailsInfoMiddleGap;
    line-height: 48px;
    font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
    font-size: 24px;
    color: #666;

    &:before {
      @include rotate(-90deg);
      content: url(../../static/images/scattered_2.png);
      display: inline-block;
      width: 78px;
      height: 81px;
      position: absolute;
      left: -160px;
      top: 145px;
    }
  }

  .product-details__right {
    display: table;
    float: right;
    position: relative;
    width: $productDetailsInfoRightWidth;

    &:before {
      content: "";
      display: none;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .7);
      position: absolute;
      left: 0;
      top: 0;
    }

    &:hover {
      .product-details__images {
        & button {
          display: block;
        }
        & .product-details__button-desc {
          display: block;
        }
      }

      &:before {
        display: block;
      }
    }
  }

  .product-details__images {
    display: table-cell;
    width: 100%;
    height: 280px;
    text-align: center;
    vertical-align: middle;
    background-color: $trueBlack;
    background-repeat: no-repeat;
    background-size: cover;

    & button {
      display: none;
      padding: 20px 0;
      border: 2px solid $white;
      width: 274px;
      height: 85px;
      color: $white;
      font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
      font-size: 36px;
      word-spacing: 0;
      background: transparent;
      cursor: pointer;
      position: absolute;
      left: 74px;
      top: 76px;

      // remove last letter spacing
      & span {
        letter-spacing: 8px;
      }
    }

    & .product-details__button-desc {
      display: none;
      margin-right: -20px; // remove last letter spacing
      margin-top: 25px;
      font-family: Anders, Arial;
      font-size: 20px;
      letter-spacing: 20px;
      color: $white;
      position: absolute;
      left: 50px;
      top: 159px;
    }
  }

  .product-details__application-conditions {
    float: right;
    margin: 105px 0 96px;
    width: 60%;
    text-align: right;

    .product-details__serial-number span {
      margin-left: 40px;
      @include rotateLeft;
    }
  }

  .product-details__application-people {
    float: left;
    margin: 96px 0;
    width: 60%;
    text-align: left;

    .product-details__serial-number span {
      margin-right: 40px;
      @include rotateRight
    }
  }

  .product-details__materials-required {
    float: right;
    margin: 96px 0;
    width: 60%;
    text-align: right;
    background: url(../../static/images/scattered_3.png) no-repeat 584px 18px;

    .product-details__serial-number span {
      margin-left: 40px;
      @include rotateLeft
    }
  }

  .product-details__suitable-city {
    float: left;
    margin: 96px 0 60px;
    width: 60%;
    text-align: left;

    .product-details__serial-number span {
      margin-right: 40px;
      @include rotateRight
    }
  }

  .product-details__serial-number {
    font-family: "Microsoft YaHei", Arial;
    font-weight: 400;
    color: $darkCyan;
    font-size: 82px;

    & span {
      color: $darkerGray;
    }
  }

  .product-details__title {
    margin: 27px 0 30px;
    @include chnTitle;
    font-size: 40px;
  }

  .product-details__title-eng {
    position: relative;
    margin: 30px 0;
    @include engTitle;
    font-size: 36px;

    &:after {
      @include rotate(90deg);
      content: url(../../static/images/scattered_2.png);
      display: inline-block;
      width: 77px;
      height: 81px;
      position: absolute;
      right: -87px;
      bottom: -10px;
    }
  }

  .product-details__title-eng.other {
    &:after {
      display: none;
    }
  }

  .product-details__title-eng.enother {
    &:after {
      right: 187px;
    }
  }

  .product-details__content {
    position: relative;
    line-height: 44px;
    color: #666;
    font-size: 24px;
    font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";

    &:before {
      @include rotate(90deg);
      content: url(../../static/images/scattered_3.png);
      display: inline-block;
      width: 78px;
      height: 81px;
      position: absolute;
      left: -840px;
      top: 0px;
    }
  }

  .product-details__content.other {
    &:before {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// ProductDetails.vue?67059bcb